import { render, staticRenderFns } from "./card-open.vue?vue&type=template&id=70ee53fa&scoped=true&"
import script from "./card-open.vue?vue&type=script&lang=ts&"
export * from "./card-open.vue?vue&type=script&lang=ts&"
import style0 from "./card-open.vue?vue&type=style&index=0&id=70ee53fa&prod&lang=scss&scoped=true&"
import style1 from "./card-open.vue?vue&type=style&index=1&id=70ee53fa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ee53fa",
  null
  
)

export default component.exports